import { type AdminEvent, type EventListener, adminSocket } from '@/lib/ws'
import { useEffect, useRef } from 'react'

/**
 * Subscribe to a realtime admin channel.
 *
 * The listener is held in a ref so callers can pass an inline arrow function
 * without retriggering the subscription on every render. Only `group` is in
 * the dep array — that prevents the subscribe → invalidate → re-render →
 * subscribe again infinite loop that fires when `listener` is unstable.
 */
export function useRealtimeChannel(
  group: string | null | undefined,
  listener: EventListener
): void {
  const listenerRef = useRef<EventListener>(listener)
  // Keep ref in sync without re-running the subscribe effect.
  listenerRef.current = listener

  useEffect(() => {
    if (!group) return
    const handler: EventListener = (event) => listenerRef.current(event)
    return adminSocket.subscribe(group, handler)
  }, [group])
}

export type { AdminEvent }
